<template>
  <div>
    <vs-card class="cardx">
      <div slot="header" style="padding:10px;height: 100%;width:100%;display:flex;align-items: center;">
        <feather-icon @click="$router.go(-1)" icon="ArrowLeftIcon"  class="cursor-pointer navbar-fuzzy-search mr-4" />
        <h3>
          {{title}}
        </h3>
      </div>
      <div>

        <vs-row >
          <vs-col  vs-lg="12" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-input
              v-model="form.name"
              type="text"
              name="name"
              v-validate="'required'"
              :danger="errors.has('name')"
              :danger-text="errors.has('name')? errors.first('name'):null"
              val-icon-danger="close"
              label="Name"
              placeholder=""
              style="width: 100%;"/>
          </vs-col>
          <vs-col  vs-lg="12" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-input
              v-model="form.description"
              name="description"
              type="text"
              v-validate="'required|min:10'"
              :danger="errors.has('description')"
              :danger-text="errors.has('description')? errors.first('description'):null"
              val-icon-danger="close"
              label="Description"
              placeholder=""
              style="width: 100%;"/>
          </vs-col>
          <vs-col  vs-lg="12" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-input
              v-model="form.Message"
              type="text"
              name="Message"
              v-validate="'required'"
              :danger="errors.has('Message')"
              :danger-text="errors.has('Message')? errors.first('Message'):null"
              val-icon-danger="close"
              label="Mensaje de Bienvenida"
              placeholder=""
              style="width: 100%;"/>
          </vs-col>
          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <label class="vs-input--label">Logo</label>
          </vs-col>
          <vs-col  vs-lg="12" vs-sm="6" vs-xs="12" style="padding:10px">
            <ImgInputer
              :img-src="(form.id && !image) ? form.image : (typeof image === 'string' ? image : null)"
              placeholder="Drop image here or click"
              bottom-text="Drop file here or click to change"
              v-model="image"
              accept="image/*"
              theme="light"
              :max-size="9000"
              @onChange="fileChange"/>
          </vs-col>

        </vs-row>
        
        <vs-row>
          <vs-col vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-button color="primary" @click="submit" type="filled">Save</vs-button>
          </vs-col>
        </vs-row>
      </div>
      <div style="margin-top: 10px;margin-bottom: 10px;">
        <vs-row>
          <vs-col vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
          <label class="vs-input--label">Zone</label>
          <v-select @input="null"
                    v-model="filters.zone_id" :options="this.zones"
                    :reduce="el => el.id" label="name"  />
          </vs-col>
        </vs-row>
      </div> 
      <div>
          <vs-table
            stripe
            :sst="true"
            :data="partners.partners">
            <template slot="thead">
              <vs-th sort-key="name">
                Name
              </vs-th>
              <vs-th sort-key="description">
                Description
              </vs-th>
              <vs-th>
                Action
              </vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :key="partner.id" v-for="partner in data">
                <vs-td>
                  {{partner.name}}
                </vs-td>
                <vs-td>
                  {{partner.description}}
                </vs-td>
                <vs-td>
                  <feather-icon icon="EditIcon" @click="null" class="cursor-pointer navbar-fuzzy-search mr-4" />
                  <feather-icon icon="SettingsIcon" @click="null" class="cursor-pointer navbar-fuzzy-search mr-4" />
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
      </div>

    </vs-card>

  </div>

</template>
<style itemscope>
  .img-inputer {
    width: 150px;
    height: 150px;
  }
</style>
<script>
  import {mapState, mapActions, mapGetters} from 'vuex';
  import ImgInputer from 'vue-img-inputer';


  export default {
    name :'PartnerAccount',
    components: {
      ImgInputer,
    },
    data(){
      return {
        title : null,
        filters:{
          zone_id: 'test'
        },
        zones:['test1','test2','test3','test4'],
        form:{
          name: null,
          description: null,
          Message: null,
        },
        onSubmit : false,
        image : null,
        imgBase64 : null,
        showCrop: false,

        data_timeline : []
      }
    },
    computed : {
      ...mapState('partners',['partners']),
      ...mapGetters('users',['userCan']),
    },
    watch :{
      '$route.params.id': function (id) {
        this.initData();
      }
    },
    created() {
      this.initData();
    },
    methods: {
      ...mapActions('partners',['getPartner','storePartner','updatePartner']),
      initData(){
        if(this.$route.params.id){
          this.title = 'Edit partner';
          this.getPartner({id: this.$route.params.id})
            .then(data=>{
              this.form = data;
              this.form['Message'] = 'test'
            })
            .catch(error=>{
              if(error){
                if(error.status === 404){
                  this.$router.push({name: 'page-error-404'});
                }
              }
            })
        }else{
          this.title = 'New partner';
          this.form = {
            name: null,
            description: null,
            Message: null,
          };
        }
      },
      async submit(){
        let result = await this.$validator.validateAll();
        if (!result || this.onSubmit) {
          return;
        }

        if(this.$route.params.id){
          if(!this.userCan('partners.update')){
            this.$vs.notify({
              color: 'danger',
              title: `Error`,
              text: 'You need permission to perform this action',
            });
            return;
          }
          this.$vs.loading({
            type:'point',
          });
          this.onSubmit = true;

          let form = _.cloneDeep(this.form);

          this.updatePartner(form)
            .then(data=>{
              this.$vs.loading.close();
              this.onSubmit = false;
              this.msgDialog('success','Success','Partner successfully updated',this.redirectToPartners);
            })
            .catch(error =>{
              this.$vs.loading.close();
              this.onSubmit = false;
              if(error){
                if(error.status === 400){
                  this.setErrors(error.data.errors);
                }
              }
            })
        }else{
          if(!this.userCan('partners.create')){
            this.$vs.notify({
              color: 'danger',
              title: `Error`,
              text: 'You need permission to perform this action',
            });
            return;
          }
          this.$vs.loading({
            type:'point',
          });
          this.onSubmit = true;
          this.storePartner(this.form)
            .then(data=>{
              this.$vs.loading.close();
              this.onSubmit = false;
              this.msgDialog('success','Success','Partner successfully created',this.redirectToPartners);
            })
            .catch(error =>{
              this.$vs.loading.close();
              this.onSubmit = false;
              if(error){
                if(error.status === 400){
                  this.setErrors(error.data.errors);
                }
              }
            })
        }
      },
      msgDialog(color, title, text, action){
        this.$vs.dialog({
          color: color,
          title: title,
          text: text,
          accept:action
        })
      },
      redirectToPartners(){
        this.$router.push({name: 'partners.list'});
      },
      fileChange(file,filename){
        let reader = new FileReader()
        reader.readAsDataURL(this.image)
        reader.onload = (event)=> {
          this.imageBase64 = reader.result.split(',').pop();
          //this.showCrop = true;
        //   setTimeout(()=>{
        //     this.$refs.cropper.replace(reader.result);
        //   },300);
        };
      },
      setErrors(errors){
        for(let key in errors){
          if(Array.isArray(errors[key])){
            this.errors.add({
              field: key,
              msg: errors[key][0]
            });
          }
        }
      },

    },

  }
</script>
